import * as types from "./types";

const mutations = {
	// Регистрация. Получить код
	[types.REGISTRATION](
		state: { registrationState: object },
		registrationState: object
	) {
		state.registrationState = registrationState;
	},

	// Проверяем код подтверждения
	[types.CONFIRMATION_CODE](
		state: { confirmationCodeState: object },
		confirmationCodeState: object
	) {
		state.confirmationCodeState = confirmationCodeState;
	},

	// Увеличить количество попыток (attempts)
	[types.INCREASE_ATTEMPTS](
		state: { increaseAttemptsState: object },
		increaseAttemptsState: object
	) {
		state.increaseAttemptsState = increaseAttemptsState;
	},

	// Номер телефона
	[types.PHONE_NUMBER](
		state: { phoneNumberState: object },
		phoneNumberState: object
	) {
		state.phoneNumberState = phoneNumberState;
	},
};

export default mutations;
